import { Route, Routes } from "react-router-dom";

import ErrorPage from "./contents/ErrorPage";
import HomePage from "./contents/HomePage";
import PdfViewer from "./contents/PdfViewer";

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/PdfViewer" element={<PdfViewer />} />


            <Route path="*" element={<ErrorPage />} />
        </Routes>
    );
};

export default AppRoutes;
